//import SearchModal from './search-modal';

export default class Navigation {
    constructor (elm) {
        this.isNavOpen = false;
        this.isSearchOpen = false;
        this.isNavStatic = false;
        this.elm = elm;
        this.burgerElms = elm.querySelectorAll('.burger');
        this.subNavAccordions = [];
        this.searchModal = null;

        // instantiate all accordions manually to have a reference to them
        window.cr.loadComponentClass('accordion')
            .then(Accordion => {                
                elm.querySelectorAll('[data-navigation-component="accordion"]').forEach((subNavAccordionElm) => {
                    this.subNavAccordions.push(new Accordion(subNavAccordionElm));
                });
            });        

        // hook up navigation toggle elements
        elm.querySelectorAll('[data-navigation-toggle-menu]').forEach((toggleElm) => {
            toggleElm.addEventListener('click', this.toggle.bind(this));
        });

        elm.querySelector('[data-navigation-toggle-search]').addEventListener('click', this.toggleSearch.bind(this));

        var body = document.body;

        window.addEventListener('scroll', x => {
            if (!topscrollAd) {
                var topscrollAd = document.querySelector('.adnm-html-topscroll-frame-wrapper');
            }
            if (!topscrollAd) {
                return;
            }

            if (topscrollAd.getBoundingClientRect().bottom > 60) {
                body.classList.add('static-navigation');

            } else if (topscrollAd.getBoundingClientRect().bottom <= 0) {
                body.classList.remove('static-navigation');
            }
        })
    }

    openSearch() {
        // If the nav is open, close that before opening the search
        if (!this.isSearchOpen && this.isNavOpen) {
            this.close();
            setTimeout(() => {
                this.openSearch();
            }, 500);
        } else {
            this.isSearchOpen = true;
            this.elm.classList.add('nav--search-open');

            if (document.body.classList.contains('static-navigation')) {
                this.isNavStatic = true;
                document.body.classList.remove('static-navigation');
            }
        }

        document.body.style.overflow = 'hidden';
    }

    closeSearch() {
        this.isSearchOpen = false;
        this.elm.classList.remove('nav--search-open');


        if (this.isNavStatic) {
            this.isNavStatic = false;
            document.body.classList.add('static-navigation');
        }

        document.body.style.overflow = '';
    }

    toggleSearch() {
        this.isSearchOpen ? this.closeSearch() : this.openSearch();
    }

    toggle() {
        this.isNavOpen ? this.close() : this.open();
    }

    open() {
        // If the search is open, close that before opening the nav
        if (!this.isNavOpen && this.isSearchOpen) {
            this.closeSearch();
            setTimeout(() => {
                this.open();
            }, 500);
        } else {
            this.isNavOpen = true;
            this.elm.classList.add('nav--open');
        }
    }

    close() {
        this.isNavOpen = false;
        this.elm.classList.remove('nav--open');
    }
}
